import CollapsibleView from "@components/molecules/CollapsibleView";
import LabelView from "@components/molecules/LabelView";
import { useTypographyStore } from "@redux/slices/typographySlice";
import React from "react";
import { useTranslation } from "react-i18next";
import { FlatList, Platform } from "react-native";
import { useTheme } from "styled-components/native";
import styled from "styled-components/native";
import { ProductDetailProps } from "@scenes/pdp/types";
import { SpaceType } from "@components/atoms/Spacer/types";

const ShippingLocation = ({ shipping_location }: ProductDetailProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const typography = useTypographyStore();
  const localSelectedLocation = Object.entries(shipping_location || {}).map(
    ([key, value]) => ({ title: [key], description: value })
  );

  const keyExtractor = (item: any, index: number) => `${item.title}-${index}`;

  const ItemCard = ({ item }: any) => (
    <>
      {item?.showNumber === undefined || item?.showNumber === true ? (
        <CustomView>
          <LabelView
            itemLeftText={t(item.title)}
            itemRightText={
              item.description === "" ? "-" : item.description ?? "-"
            }
            rightPrefixTextTheme={theme["core-05"]}
            leftPostfixText=""
            itemLeftTextTheme={theme["core-06"]}
            cellWidth={theme.isMobile ? 250 : 200}
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            isFixedKeyWidth={true}
            keyWidth={50}
            keyWidthPercent={theme.isMobile ? 35 : 18}
            ellipsize={false}
            isFixWidth
          />
        </CustomView>
      ) : null}
    </>
  );

  return (
    <>
      <CollapsibleView
        initExpanded={true}
        title={t("requestHistoryDetail.shippingAddress.text")}
        arrowStyling={{ color: theme["core-04"] }}
        applyShadow
        applyTopPadding={false}
        applyBottomPadding={false}
      >
        <Divider />
        <Container>
          <FlatList
            data={localSelectedLocation}
            renderItem={({ item }) => <ItemCard item={item} />}
            keyExtractor={keyExtractor}
            scrollEnabled={Platform.OS === "web" ? true : false}
          />
        </Container>
      </CollapsibleView>
    </>
  );
};

const Container = styled.View`
  padding-vertical: ${SpaceType.Basic}px;
  padding-horizontal: ${SpaceType.Double}px;
`;

const CustomView = styled.View`
  justify-content: flex-start;
  margin-vertical: 4px;
`;

const Divider = styled.View`
  height: 1px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["core-03"]};
  width: 100%;
  max-width: 100%;
`;

export default ShippingLocation;
